 
import WebOffice from '../../../webOffice/index';  

export default{
    components: {//自定义组件列表 
        'web-office':WebOffice, 
	},
    data() {
        
        return {
            breadcrumb:[{
                name:'首页', path:'/home'
            },{
                name:'收文列表', path:'/oa/official/receive/1'
            },{
                name:'收文详情', path:''
            }], 
            currKey:'',
            apis:{//接口列表 
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传   
                save:'oa/official/receive/save',//保存
                bykey:'oa/official/receive/byKey',//详情
                fileNumList:'oa/fn/cfg/list', //文号配置列表
                getFileNum:'oa/fn/cfg/getFileNum',
                getWfTask:'/oa/official/getWFTask',//任务详情
                sign: 'sh/wf/task/sign', //签收任务 
                abort: '/oa/official/abort', //撤销
                reset: '/oa/official/reset', //重置
            }, 
            editObj:{
                title:"",
                fileKey:"", 
            },
            wfFlowModel:{
                finish:false,
                turn:false,
            },
            key:"",
            fileList:[],//源文件
            enclosureList:[],//附件 
            userWnd: false,//是否显示人员选择窗口
            rules:{
                fileKey:[{ required: true, message: '请上传源文件', trigger: 'change' }],
                title:[{ required: true, message: '请输入标题', trigger: 'blur' }],
                fileNumStr:[{ required: true, message: '请输入文号', trigger: 'blur' }],
                category:[{ required: true, message: '请选择文档归类', trigger: 'change' }],
                sourceUnit:[{ required: true, message: '请选择来文单位', trigger: 'change' }],
                fileNumCfgKey:[{ required: true, message: '请选择文号设置', trigger: 'change' }],
            },
            fileNumList:[],
            WFtask:{}, 
            officialFileList:[],
            webShow: false,
            docFileKey:'',
            fileType:".docx",
            drawer:false
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        bizKey: String,
        taskKey: String,
    },
    watch: {
        bizKey() { 
            this.init();
        }, 
    }, 
    mounted() { 
        this.init();
    },                     
    methods: {
        init(){
            this.key = this.bizKey;
            let taskKey = this.taskKey;
            if (this.key > -1) {
                this.find();
            }
            if (taskKey > -1) {
                this.getWfTask(taskKey);
            }
        },
        getWfTask(taskKey){  
            this.$post({
                url: this.apis.getWfTask,
                params:taskKey,  
            }).then(rsp => {
                if(rsp.success){
                    this.WFtask = rsp.retObj; 
                    if(this.WFtask.type==2){
                        this.sign();
                    }
                }
            })
        },
        sign(){
            const me = this;
            me.$post({
                url: me.apis.sign,
                params: me.WFtask.id
            }).then(rsp => {
                if(rsp.success){ 
                    me.$message.success("签收成功");
                }
            })
        },
        find(){
            const me = this;
            me.key = me.bizKey;
            me.fileList=[];
            me.enclosureList=[];
            me.$post({
                url: me.apis.bykey,
                params:me.key,  
            }).then(rsp => {
                if(rsp.success){
                    me.editObj=rsp.retObj;
                    me.fileList.push(rsp.retObj.fileInfo);
                    me.enclosureList=rsp.retObj.enclosureList;
                    me.officialFileList=rsp.retObj.officialFileList; 
                    me.$delete(me.editObj,'fileInfo');
                    me.$delete(me.editObj,'enclosureList');
                }
            })
        }, 
        goBack(){ 
            this.$router.go(-1);
        },  
        showFile(){
            if(this.fileList.length>0){
                this.handlePreview(this.fileList[0]);
            }
        },
        handlePreview(file){ 
            if(file.path){
                if(file.path.includes(".docx")||file.path.includes(".xlsx")||file.path.includes(".doc")||file.path.includes(".xls")){
                    // this.docFileKey=file.id;
                    // this.fileType=file.path.substring(file.path.lastIndexOf("."),file.path.length);
                    // this.webShow=true;
                    let {href}  = this.$router.resolve({ 
                        path: "/oa/office/browerDialog",
                        query:{
                            isView:1,
                            bizKey:this.key,
                            fileType:file.path.substring(file.path.lastIndexOf("."),file.path.length),
                            bizType:2,
                            fileId:file.id 
                        }
                    })    
                    this.winDialog=window.open(href,"_blank"," left=0,top=0,width="+ (screen.availWidth - 10) +",height="+ (screen.availHeight-50) +",toolbar=no, menubar=no, scrollbars=no,location=no, status=no");
                
                }else if(file.path.includes(".txt") ||file.path.includes(".pdf") || file.path.includes(".PDF") || file.path.includes(".png") || file.path.includes(".PNG")|| file.path.includes(".jgp") || file.path.includes(".JPG")|| file.path.includes(".gif") || file.path.includes(".GIF")){
                    const url = this.$global.baseUrl + file.path;
                    window.open(url, '_blank');
                } 
                else{
                    const url = this.$global.baseUrl + 'sh/file/download?id=' + file.id;
                    window.open(url, '_blank');
                }
            } 
        }, 
        print(){
            let {href}  = this.$router.resolve({ path: '/oa/official/receive/print/'+this.key })
            window.open(href, '_blank') 
        },
        toSend(item){ 
            this.$emit('changeBiz',item.bizKey,1);  
        },
        //重置收文
        reset() { 
            this.$confirm('是否确认重置文件?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {};
                params.key = this.key;
                params.bizType = 2;
                params.instKey = this.editObj.instKey;
                this.$post({
                    url: this.apis.reset,
                    params: params
                }).then(rsp => {
                    this.$emit('close');
                    this.$message.success("重置成功!");
                })
            }).catch(() => {

            }); 
        },
        getReadPower(v){ 
            if(v==1){
                return "会员";
            }else if(v==2){
                return "游客";
            }else{ 
                return "禁止查看";
            }
        },
        downloadFile(row){
            const url = this.$global.baseUrl + 'sh/file/download?id=' + row.id;
            window.open(url, '_blank');
        },
        downloadAll(){
            const url = this.$global.baseUrl +"oa/official/downloadFileAll?bizKey=" + this.key;
            window.open(url, '_blank');
           
        },
        close(){
            
        },
        callback(){
            
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/official/receive/view/view.js